module.exports = __webpack_public_path__ + "9bafbc98854c11290e5436ca21470d5f.ttf";